import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { logger } from "@/lib/logger";
import { db } from '@/lib/firebase';
import {
  TaskPreferences,
  defaultTaskPreferences,
} from '@/types/taskPreferences';

/**
 * Get user's task preferences
 */
export async function getTaskPreferences(
  userId: string
): Promise<TaskPreferences> {
  try {
    const docRef = doc(db, 'users', userId, 'private', 'taskPreferences');
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      return defaultTaskPreferences;
    }

    return docSnap.data() as TaskPreferences;
  } catch (error) {
    logger.error('Error getting task preferences:', error);
    return defaultTaskPreferences;
  }
}

/**
 * Update user's task preferences
 */
export async function updateTaskPreferences(
  userId: string,
  preferences: Partial<TaskPreferences>
): Promise<void> {
  try {
    const docRef = doc(db, 'users', userId, 'private', 'taskPreferences');
    
    await setDoc(
      docRef,
      {
        ...preferences,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
  } catch (error) {
    logger.error('Error updating task preferences:', error);
    throw error;
  }
}
